export class AccessTokenError extends Error {
    constructor() {
        super();
        this.message = "Failed to acquire access token.";
    }
}